import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import { RevelioPageId } from '../PageConfigProvider/types';
import { useTableSelection } from '../TableSelectionProvider/TableSelectionProvider';
import { TalentDiscoverySourceWhaleButton } from '../TableSelectionProvider/TalentDiscoverySourceWhaleButton';
import styles from './custom-dash-action-bar.module.css';

export const CustomDashActionBar = () => {
  const { revelioPageId } = useTabContentConfig();
  const { selectedRows } = useTableSelection();

  return (
    <div className={styles.actionBar}>
      {revelioPageId === RevelioPageId.TALENT_DISCOVERY && (
        <TalentDiscoverySourceWhaleButton selectedRows={selectedRows ?? []} />
      )}
    </div>
  );
};
